'use client';

import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren, createContext, use } from 'react';
import { useCrossPlatformGatingInput } from '@/hooks/useCrossPlatformGatingInput';
type CrossPlatformGatingContextValue = ReturnType<typeof useCrossPlatformGatingInput>;
const CrossPlatformGatingContext = createContext<CrossPlatformGatingContextValue | null>(null);
export function CrossPlatformGatingProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const value = useCrossPlatformGatingInput();
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <CrossPlatformGatingContext.Provider value={value}>{children}</CrossPlatformGatingContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function useCrossPlatformGatingContext(): CrossPlatformGatingContextValue {
  const value = use(CrossPlatformGatingContext);
  if (value == null) {
    throw new Error('useCrossPlatformGatingContext cannot be used outside of CrossPlatformGatingProvider');
  }
  return value;
}